import React from "react";
import { BookOpenIcon, TimerIcon, HelpCircleIcon, NotebookPenIcon, RepeatIcon, SproutIcon, ClipboardCheckIcon, MapIcon, BarChart3Icon, CalendarDaysIcon, BoxIcon } from "lucide-react";
const map: Record<string, BoxIcon> = {
  books: BookOpenIcon,
  timer: TimerIcon,
  question: HelpCircleIcon,
  notes: NotebookPenIcon,
  repeat: RepeatIcon,
  sprout: SproutIcon,
  checklist: ClipboardCheckIcon,
  map: MapIcon,
  chart: BarChart3Icon,
  calendar: CalendarDaysIcon
};
export function Icon({
  name,
  className
}: {
  name: string;
  className?: string;
}) {
  const Cmp = map[name] ?? BookOpenIcon;
  return <Cmp className={className} aria-hidden="true" data-id="element-40" data-mp="2gwri610db88g" />;
}